import type { AdoptionMetricRow } from '../../customersuccess/framework';

type Props = { metrics?: AdoptionMetricRow[] };

export function ProductAdoptionPanel({ metrics = [] }: Props) {
  return (
    <div className="space-y-2">
      {metrics.map((m) => (
        <div key={m.metric} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{m.metric}</p>
            <p className="mt-0.5 text-xs text-slate-500">target: {m.target}</p>
          </div>
          <div className="shrink-0 text-right">
            <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">{m.value}</p>
            <p className="text-xs text-success-600">{m.change}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
